import { useEffect, useState } from "react";
import { usePopper } from "react-popper";
import InvoiceFilterModal from "../modals/invoice/InvoiceFilterModal";
import OpportunityFilterModal from "../modals/opportunity/OpportunityFilterModal";
import { useTranslation } from "../../hooks/useTranslation";

export function OpportunityFilter({
  awailableColumns,
  selectedColumns,
  toggleColumn,
  setFilter,
  filter,
  setShowModalNew,
  proccessStateNamesToIds,
}) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const isFilterState = (state) => {
    return filter.current_state_id_name?.includes(state);
  };

  const toggleFilterState = (state) => {
    if (isFilterState(state)) {
      filter?.current_state_id_name.splice(
        filter?.current_state_id_name.indexOf(state),
        1
      );
    } else {
      filter?.current_state_id_name?.push(state);
    }
    setFilter({
      ...filter,
      current_state_id: proccessStateNamesToIds(filter.current_state_id_name),
    });
    console.log(filter);
  };

  return (
    <div
      className="d-lg-flex justify-content-end text-end text-md-start"
      data-kt-customer-table-toolbar="base"
    >
      <span className="d-none d-md-inline">
        <button
          type="button"
          className={
            "btn me-3 mb-2 " +
            (isFilterState("open") ? "btn-warning" : "btn-secondary")
          }
          onClick={() => toggleFilterState("open")}
        >
          {t("opportunities.open")}
        </button>

        <button
          type="button"
          className={
            "btn me-3 mb-2 " +
            (isFilterState("order") ? "btn-warning" : "btn-secondary")
          }
          onClick={() => toggleFilterState("order")}
        >
          {t("opportunities.ordered")}
        </button>

        <button
          type="button"
          className={
            "btn me-3 mb-2 " +
            (isFilterState("invoiced") ? "btn-success" : "btn-secondary")
          }
          onClick={() => toggleFilterState("invoiced")}
        >
          {t("opportunities.invoiced")}
        </button>
      </span>

      <button
        type="button"
        className="btn btn-primary me-3 mb-2"
        onClick={() => setShowModalNew(true)}
      >
        <i className="ki-duotone ki-plus fs-2">
          <span className="path1"></span>
          <span className="path2"></span>
        </i>
        {t("opportunities.newCalculation")}
      </button>

      <button
        type="button"
        className="btn btn-light-primary me-3"
        onClick={() => setShowModal(true)}
      >
        <i className="ki-duotone ki-filter fs-2">
          <span className="path1"></span>
          <span className="path2"></span>
        </i>
        {t("common.filter")}
      </button>

      <OpportunityFilterModal
        filter={filter}
        setFilter={setFilter}
        awailableColumns={awailableColumns}
        toggleColumn={toggleColumn}
        selectedColumns={selectedColumns}
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </div>
  );
}
